import { Pages } from "modules/BookingCommon/common/constants"

const allPages = [Pages.CARDS, Pages.SESSION_DATE, Pages.FORM, Pages.PAYMENT]

const pagesWithSkippedCards = [Pages.SESSION_DATE, Pages.FORM, Pages.PAYMENT]

const timeRequestFlow = [Pages.CARDS, Pages.FORM, Pages.PAYMENT]

export { allPages, pagesWithSkippedCards, timeRequestFlow }
